import type { MetaFunction } from "@remix-run/cloudflare";
import { useState } from "react";
import Footer from "~/components/Footer";
import styles from "~/styles/contact.module.css";

export const meta: MetaFunction = () => [
  { title: "Contact — Prodigium Dynamics" },
  { name: "description", content: "Get in touch with Prodigium Dynamics." },
];

export default function ContactPage() {
  const [sent, setSent] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSent(true);
  }

  return (
    <>
      <div className={styles.pageWrap}>
        <div className={styles.signalPanel}>
          <div className={styles.signalCore}>
            <div className={styles.signalDot} />
            <div className={styles.signalRing} />
            <div className={`${styles.signalRing} ${styles.r2}`} />
            <div className={`${styles.signalRing} ${styles.r3}`} />
            <div className={`${styles.signalRing} ${styles.r4}`} />
          </div>
          <p className={styles.signalLabel}>Signal</p>
          <h2 className={styles.signalStatus}>
            Open.<br /><span>Receiving.</span>
          </h2>
          <p className={styles.signalDesc}>
            Real humans. Real conversations. We read every message and respond to the ones that matter.
          </p>
        </div>

        <div className={styles.contactPanel}>
          <p className={styles.contactEyebrow}>Get in touch</p>
          <h1 className={styles.contactTitle}>Let&apos;s<br />build.</h1>
          <p className={styles.contactStatement}>
            Building something that deserves to exist? Working on a problem that hasn&apos;t been solved yet?
            We&apos;re interested in both.
          </p>

          <div className={styles.humanBadge}>
            <span className={styles.humanDot} />
            <span>Answered by a human. No bots.</span>
          </div>

          {sent ? (
            <div className={styles.successMsg}>
              <p>Message received. We&apos;ll be in touch.</p>
            </div>
          ) : (
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={styles.label}>Name</label>
                  <input className={styles.input} type="text" placeholder="Your name" required />
                </div>
                <div className={styles.formGroup}>
                  <label className={styles.label}>Email</label>
                  <input className={styles.input} type="email" placeholder="your@email.com" required />
                </div>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Subject</label>
                <input className={styles.input} type="text" placeholder="What's this about?" />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Message</label>
                <textarea className={styles.textarea} placeholder="What are you working on?" rows={5} />
              </div>
              <button type="submit" className={styles.submitBtn}>Send Message →</button>
            </form>
          )}

          <div className={styles.altContact}>
            <p className={styles.altLabel}>Or reach us directly</p>
            <a href="mailto:global@prodigiumdynamics.space" className={styles.altLink}>
              global@prodigiumdynamics.space
            </a>
            <a href="https://t.me/prodigiumdynamics" target="_blank" rel="noopener" className={styles.altLink}>
              Telegram — Customer Support →
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
